import { handleError } from '../../general/errorHandling'
import { PRICE_MODEL_SORT_ORDER } from '../../general/master-data'
import { useCruiseListStore } from '../cruise-list'
import { IMapCruiseGridResult, IPrice } from '../cruise-list/interfaces'
import { availablePriceModels } from './helper'

export const priceModels = () => {
  const cruiseListStore = useCruiseListStore()
  
  const cruise = cruiseListStore.cruiseList.find(
    (entry: IMapCruiseGridResult) => entry.id === cruiseListStore.selectedEntryId
  )

  if (!cruise) {
    handleError({ error: new Error('cruise could not be found'), origin: 'detailsGetter - priceModels' })
    return []
  }

  return availablePriceModels(cruise)
}

export const firstAvailablePriceModel = () => {
  const cruiseListStore = useCruiseListStore()

  const cruise: IMapCruiseGridResult | undefined = cruiseListStore.cruiseList.find((entry: IMapCruiseGridResult) => {
    return entry.id === cruiseListStore.selectedEntryId
  })

  if (!cruise) {
    handleError({ error: new Error('cruise could not be found'), origin: 'firstAvailablePriceModel' })
    return null
  }

  for (const sortPriceModel of PRICE_MODEL_SORT_ORDER) {
    const priceModelPricings = cruise[sortPriceModel.toLowerCase() as keyof IMapCruiseGridResult] as IPrice
    
    if (!!priceModelPricings.categories) {
      return sortPriceModel
    }
  }

  return null
}

export default {
  priceModels,
  firstAvailablePriceModel,
}
